const Rollbar = require('rollbar');

// It will be available to code always.
window.Rollbar = new Rollbar({ enabled: false });

// Real configuration should be provided by cms templates.
// This will enable it, provide api key and other options.
if (window.RollbarConfig) {
  // Replace host for sourcemaps.
  // https://docs.rollbar.com/docs/source-maps#using-source-maps-on-many-domains
  window.RollbarConfig.transform = function (payload) {
    const { trace } = payload.body;
    let i;
    if (!trace || !trace.frames) return;
    for (i = 0; i < trace.frames.length; i++) {
      const { filename } = trace.frames[i];
      if (filename) {
        trace.frames[i].filename = filename.replace(
          window.location.hostname,
          'dynamichost'
        );
      }
    }
  };

  window.RollbarConfig.checkIgnore = function (isUncaught, args, payload) {
    const { trace } = payload.body;

    if (
      !trace ||
      !trace.frames.length ||
      trace.frames[0].filename === '(unknown)' ||
      !trace.frames[0].lineno
    ) {
      return true;
    }

    return false;
  };

  window.Rollbar.configure(window.RollbarConfig);
}
